<template>
  <div class="child-view">
    <van-sticky>
      <!-- <div class="tabsStyle">
        <div :style="tabsStyleXz">河南得贤</div>
        <div :style="tabsStyleXz">佰龄康护</div>
      </div> -->
      <div style="background-color: white">
        <van-tabs swipeable
          @click="onClickTab"
          color="#4393ff"
          background="#4393ff00"
          title-active-color="#4393ff"
          style="width:60%;">
          <van-tab v-for="item in soIdList"
            :key="item.Id"
            :name="item.Id"
            :title="item.Name">
          </van-tab>
        </van-tabs>
      </div>
    </van-sticky>
    <div style="width: 95%; margin: auto">
      <div style="margin-top: 10px">
        <div class="boxStyle boxStyleBg"
          style="color: white">
          <!-- <div class="title">当天服务情况</div> -->
          <div>
            <!-- <div class="nowTime"
              style="margin-left:10px;">{{list.soName}}</div> -->
            <div class="nowTime">
              {{ nowTime }}
            </div>
          </div>

          <div class="boxTopCount">
            <div class="boxTopCount01">
              <div class="money moneyBottom">
                {{ list.curStaffNum }}
              </div>
              <div style="margin-bottom: 10px">员工数</div>
            </div>
            <div class="boxTopCount01">
              <div class="money moneyBottom">
                {{ list.curOndutyNum }}
              </div>
              <div style="margin-bottom: 10px">出勤数</div>
            </div>
            <div class="boxTopCount01">
              <div class="money moneyBottom">
                {{ list.curUnOndutyNum }}
              </div>
              <div style="margin-bottom: 10px">未出勤</div>
            </div>
          </div>
          <div class="boxTopCount"
            style="margin-top: 25px">
            <div class="boxTopCount01">
              <div>服务数</div>
              <div class="money moneyTop">
                {{ list.curWoNum }}
              </div>
            </div>
            <div class="boxTopCount01">
              <div>单人最大</div>
              <div class="money moneyTop">
                {{ list.curMaxNum }}
              </div>
            </div>
            <div class="boxTopCount01">
              <div>单人最小</div>
              <div class="money moneyTop">
                {{ list.curMinNum }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 当月服务情况 -->
      <div class="boxStyle"
        style="background: white; padding: 10px; margin-top: 10px">
        <div class="biankuang">
          <div class="biankuang1"></div>
          <div style="font-size: 16px; margin-left: 10px; line-height: 20px">
            当月
          </div>
        </div>
        <div style="width: 100%; margin: 10px auto">
          <div id="nowMonth"
            style="width: 100%; height: 160px"></div>
        </div>
        <div class="boxOldman"
          style="margin-top: 0">
          <div class="boxStyle boxStyle01">
            <div class="oldmanNum">
              <div style="margin-bottom: 5px; font-size: 14px">服务总数</div>
            </div>
            <div class="oldmanBottom">
              <div class="oldmanBottomCount"
                style="color: #13a8ff">
                {{ list.woNum }}
              </div>
              <div class="oldmanImg">
                <img src="https://jmylapi.zhsq.cloud//upload/files/2022/11/qyhv88b1f3k661b212ddf73f68818d44aa0420c5243f.png" />
              </div>
            </div>
          </div>
          <div class="boxStyle boxStyle02">
            <div class="oldmanNum">
              <div style="margin-bottom: 5px; font-size: 14px">单人最大</div>
            </div>
            <div class="oldmanBottom">
              <div class="oldmanBottomCount"
                style="color: #feaa0d">
                {{ list.maxNum }}
              </div>
              <div class="oldmanImg">
                <img src="https://xajmylapi.anluoyun.cn//upload/images/2022/11/b8229816-e08.png" />
              </div>
            </div>
          </div>
          <div class="boxStyle boxStyle03">
            <div class="oldmanNum">
              <div style="margin-bottom: 5px; font-size: 14px">单人最小</div>
            </div>
            <div class="oldmanBottom">
              <div class="oldmanBottomCount"
                style="color: #00cb83">
                {{ list.minNum }}
              </div>
              <div class="oldmanImg">
                <img src="https://xajmylapi.anluoyun.cn//upload/images/2022/11/5883b208-db7.png" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 服务趋势 -->
      <div class="boxStyle"
        style="background: white; padding: 10px; margin-top: 10px">
        <div class="biankuang">
          <div class="biankuang1"></div>
          <div style="font-size: 16px; margin-left: 10px; line-height: 20px">
            服务动态
          </div>
        </div>
        <div style="width: 100%; margin: 10px auto 0">
          <div id="qushi"
            style="width: 100%; height: 180px"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { UnitWorkorderStat, UnitWorkorderTrend, GetSerOrganList } from "@/api/oldman";
export default {
  data () {
    return {
      soId: "6",
      nowTime: "", //当天日期
      list: {},
      soIdList: [
        { Id: 6, Name: "河南得贤" },
        { Id: 8, Name: "佰龄康护" },
      ],
    };
  },
  mounted () {
    var now = new Date();
    var year = now.getFullYear();
    var month = now.getMonth() + 1;
    var day = now.getDate();
    month = month.toString().padStart(2, "0"); // 当小于10时，显示为01.02.03
    day = day.toString().padStart(2, "0"); // 当小于10时，显示为01.02.03
    this.nowTime = `${year}-${month}-${day}`; // 拼接日期

    this.tabsStyleXz = {
      "background-color": "white",
      color: "#4393ff",
    };
    this.getSerOrganList();
    this.getUnitWorkorderStat();
    this.getWorkOrderTrend();

  },
  methods: {
    getSerOrganList () {
      GetSerOrganList().then((res) => {
        if (res.data.code == 0) {
          this.soIdList = res.data
        }
      }).catch(() => {
        console.log('网络异常');
        console.log(123);
      })
    },
    onClickTab (name, title) {
      //   this.list = {}
      this.soId = name;
      this.getUnitWorkorderStat();
      this.getWorkOrderTrend();
    },
    getUnitWorkorderStat () {
      UnitWorkorderStat({ soId: this.soId }).then((res) => {
        if (res.data.code == 0) {
          this.list = res.data;
          this.nowMonth(res.data);
        }
      });
    },
    nowMonth (row) {
      var m2R2Data = [
        // {
        //   value: row.staffNum,
        //   name: "员工数",
        //   itemStyle: { color: "#6897ed" },
        // },
        {
          value: row.finishNum,
          //   name: "完成数 " + row.finishNum,
          name: "完成数",
          itemStyle: { color: "#47cb84" },
        },
        {
          value: row.partedNum,
          //   name: "未完成 " + row.partedNum,
          name: "未完成",
          itemStyle: { color: "#f46463" },
        },
        {
          value: row.unSerNum,
          //   name: "未服务 " + row.unSerNum,
          name: "未服务",
          itemStyle: { color: "#f59901" },
        },
      ];
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById("nowMonth"));
      var that = this;
      // 绘制图表
      myChart.setOption({
        title: [
          {
            text: "总数",
            subtext: row.serOmNum,
            subtextStyle: {
              fontSize: 20,
              color: "#5E95ED",
            },
            textStyle: {
              fontSize: 20,
              color: "black",
            },
            textAlign: "center",
            x: "28.5%",
            y: "30%",
          },
        ],
        legend: {
          type: "scroll",
          orient: "vertical",
          left: "60%",
          align: "left",
          top: "middle",
          itemWidth: 18, // 图例标记的图形宽度。[ default: 25 ]
          itemHeight: 5, // 图例标记的图形高度。[ default: 14 ]
          formatter: (name) => {
            return (
              "{title|" + name + "} {value|" + m2R2Data.find((item) => {
                return item.name == name
              }).value + "}"
            );
          },
          textStyle: {
            rich: {
              title: {
                fontSize: 14,
                color: "#999999",
              },
              value: {
                fontSize: 16,
                color: "##333333",
              },
            },
          },
          height: 250,
        },
        series: [
          {
            type: "pie",
            center: ["30%", "45%"],
            radius: ["80%", "60%"],
            // radius: ["70%", "50%"],
            clockwise: false, //饼图的扇区是否是顺时针排布
            avoidLabelOverlap: false,
            label: {
              show: false,
            },
            data: m2R2Data,
          },
        ],
      });
    },
    // 服务趋势
    getWorkOrderTrend () {
      UnitWorkorderTrend({ soId: this.soId }).then((res) => {
        var list = res.data;
        if (list.code == 0) {
          var StatDay = [];
          var OrderCount = [];
          //   console.log(list.data);
          if (list.data.length == "1") {
            for (let i = 0; i < list.data[0].Detail.length; i++) {
              const e = list.data[0].Detail[i];
              StatDay.push(e.Days);
              OrderCount.push(e.SerNum);
            }
            this.getTxTongJi(StatDay, OrderCount);
          }
        }
      });
    },
    getTxTongJi (StatDay, OrderCount) {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById("qushi"));
      // 绘制图表
      myChart.setOption({
        tooltip: {},
        grid: {
          top: "11%",
          left: "1%",
          right: "1%",
          bottom: "8%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: true,
            axisLine: {
              //坐标轴轴线相关设置。数学上的x轴
              show: true,
              lineStyle: {
                color: "#f9f9f9",
              },
            },
            axisLabel: {
              //坐标轴刻度标签的相关设置
              interval: 0, //横轴信息全部显示
              rotate: 60, //60度角倾斜显示
              textStyle: {
                color: "black",
                margin: 15,
              },
            },
            axisTick: {
              show: false,
            },
            data: StatDay,
          },
        ],
        yAxis: [
          {
            type: "value",
            min: 0,
            // max: 140,
            splitNumber: 7,
            splitLine: {
              show: true,
              lineStyle: {
                color: "#eee",
              },
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#eee",
              },
            },
            axisLabel: {
              margin: 20,
              textStyle: {
                color: "black",
              },
            },
            axisTick: {
              show: false,
            },
          },
        ],
        series: [
          {
            name: "注册总量",
            type: "line",
            smooth: true, //是否平滑曲线显示
            // 			symbol:'circle',  // 默认是空心圆（中间是白色的），改成实心圆
            showAllSymbol: true,
            symbol: "emptyCircle",
            symbolSize: 6,
            lineStyle: {
              normal: {
                color: "#54bdff", // 线条颜色
              },
              borderColor: "#f0f",
            },
            label: {
              show: true,
              position: "top",
              textStyle: {
                color: "black",
              },
            },
            itemStyle: {
              normal: {
                color: "#7099ed",
              },
            },
            tooltip: {
              show: false,
            },
            areaStyle: {
              //区域填充样式
              normal: {
                //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
                color: this.$echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "rgba(55, 148, 255,1)",
                    },
                    {
                      offset: 1,
                      color: "rgba(55, 148, 255, 0)",
                    },
                  ],
                  false
                ),
                shadowColor: "rgba(53,142,215, 0.9)", //阴影颜色
                shadowBlur: 20, //shadowBlur设图形阴影的模糊大小。配合shadowColor,shadowOffsetX/Y, 设置图形的阴影效果。
              },
            },
            data: OrderCount,
          },
        ],
      });
    },
  },
};
</script>
<style scoped>
/* pages/notice/notice.wxss */
.child-view {
  min-height: 100%;
  background-color: #f5f5f5;
  background-image: url(https://xajmylapi.anluoyun.cn//upload/images/2022/11/cc3caaae-10d.png)
    no-repeat center center;
  background-size: 100% 100%;
}
.tabsStyle {
  /* display: flex;
  justify-content: space-around; */
  background: #4393ff;
  /* padding: 10px; */
}
.tabsStyle {
}
.tabsStyle div {
  padding: 5px 10px;

  border-radius: 5px;
}
.boxStyleBg {
  background: url(https://xajmylapi.anluoyun.cn//upload/images/2022/11/7bafcde9-d55.png)
    no-repeat center center;
  background-size: 100% 100%;
  /* background: linear-gradient(to bottom, #ffb150 0%, #ea561d 100%); */
}
.nowTime {
  margin-top: 10px;
  margin-right: 10px;
  text-align: right;
  font-size: 14px;
}
.boxStyle {
  /* border: 1px solid red; */
  /* background: white; */
  padding: 5px;
  border-radius: 8px;
  /* margin-top: 10px; */
}
.moneyTop {
  margin-top: 5px;
  font-size: 18px;
  font-weight: 550;
}
.moneyBottom {
  font-weight: 550;
  font-size: 20px;
  margin-bottom: 5px;
}
.title {
  font-size: 18px;
  font-weight: 550;
  margin: 10px 10px 0 10px;
}

.boxTopCount01 {
  width: 33%;
  text-align: center;
  font-size: 14px;
}

.miaoshu {
  font-weight: 550;
  font-size: 14px;
  /* color:#ababab; */
}

.boxTopCount {
  display: flex;
  justify-content: space-between;
  margin: 10px 10px;
}

.biankuang {
  /* border-left: 4px solid #6182FA; */
  width: 95%;
  margin: 10rpx auto;
}

.biankuang1 {
  /* border-left: 4px solid #6182FA; */
  border: 2px solid #13a8ff;
  background-color: #13a8ff;
  width: 0;
  height: 17px;
  float: left;
  border-radius: 2px;
}

.image {
  width: 16px;
  height: 16px;
  margin-right: 14rpx;
}

.monthMaxCard {
  display: flex;
  justify-content: space-around;
}

.count {
  font-size: 18px;
  font-weight: 550;
  padding-top: 5px;
}
.tabclass .van-tabs__wrap .van-tabs__scroll {
  width: 95%;
  margin: auto !important;
}
.boxOldman {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}
.oldmanNum {
  margin: 5px 10px;
}
.oldmanBottom {
  margin-top: 5px;
  display: flex;
  justify-content: space-between;
  font-weight: 550;
}
.oldmanBottomCount {
  padding-left: 10px;
  font-size: 18px;
}
.oldmanImg {
  margin-top: 5px;
}

.oldmanImg img {
  width: 33px;
  height: 33px;
}
.boxStyle01 {
  width: 29%;
  background-color: #edf8ff;
  /* display: flex; */
}
.boxStyle02 {
  width: 29%;
  background-color: #fef7ec;
}
.boxStyle03 {
  width: 29%;
  background-color: #edfbf5;
}
.parentClass01 {
  color: #00cb83 !important;
  font-size: 18px;
}

.parentClass02 {
  color: #feaa0d !important;
  font-size: 20px;
}

.parentClass03 {
  color: #6182fa !important;
  font-size: 18px;
}
</style>